module.exports = __webpack_public_path__ + "static/media/PM58.da79fc1a.png";